import React from "react";
// Icon Imports
import {
  MdPerson,
  MdLock
} from "react-icons/md";

import { 
	FaHouse, 
	FaShieldHalved, 
} from "react-icons/fa6";

import SignIn from "views/auth/SignIn";
import Register from "views/auth/Register";
import AcceptReferral from "views/auth/AcceptReferral";
import VerifyAccount from "views/auth/VerifyAccount";
import Dashboard from "views/my/dashboard";
import Profile from "views/admin/profile";

import accessRightsRoutes from "views/admin/access-rights/routes";
import userRoutes from "views/admin/users/routes";
import accessGroupsRoutes from "views/admin/access-groups/routes";
import modulesRoutes from "views/admin/modules/routes";
import jobPostRoutes from "views/public/job-posts/routes";
import myProfileRoutes from "views/my/profile/routes";
import { MODULE_ACCESS_MANAGEMENT_MENU, 
	MODULE_DASHBOARD 

} from "variables/constants";
import { LogIn, UserPlus } from "lucide-react";

const routes = [
	...jobPostRoutes,
	...myProfileRoutes,
	{
		name: "Sign In",
	    layout: "/auth",
	    path: "auth/sign-in",
	    icon: <LogIn className="icon-item" />,
	    component: <SignIn />,
	    isMainMenu:true,
		moduleId: 0,
		level:5,
  	},
	{
		name: "Register",
	    layout: "/auth",
	    path: "register",
	    icon: <UserPlus className="icon-item" />,
	    component: <Register />,
	    isMainMenu:true,
		moduleId: 0,
		level:5,
  	},
	{
		name: "Accept Referral",
	    layout: "/auth",
	    path: "/accept/referral/:code",
	    icon: <UserPlus className="icon-item" />,
	    component: <AcceptReferral />,
	    isMainMenu:false,
		moduleId: 0,
		level:5,
  	},
	{
		name: "Verify Account",
	    layout: "/auth",
	    path: "auth/verify-account",
	    icon: <UserPlus className="icon-item" />,
	    component: <VerifyAccount />,
	    isMainMenu:false,
		moduleId: 0,
		level:5,
  	},
  	{
    	name: "Profile",
    	layout: "/admin",
    	path: "profile",
    	icon: <MdPerson className="icon-item" />,
    	component: <Profile />,
    	isMainMenu:false,
  	},
  	// {
    // 	name: "Dashboard",
	//     layout: "/my",
	//     path: "dashboard",
	//     icon: <FaHouse className="icon-item" />,
	//     component: <Dashboard />,
	//     isMainMenu:true,
	// 	level:5,
	// 	moduleId: MODULE_DASHBOARD,
  	// },
  	{
	    name: "Access Management",
	    layout: "/console",
	    path: "#",
	    icon: <FaShieldHalved className="icon-item"/>,
	    component: null,
	    isMainMenu:true,
		level:2,
		moduleId: MODULE_ACCESS_MANAGEMENT_MENU,
	    children: [
			...userRoutes,
			...accessGroupsRoutes,
			...accessRightsRoutes,
			...modulesRoutes,
		]
  	},
];

export default routes;
